module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202505",
		"fund_id": 187,
		"net_asset_sum": 9305172528706,
		"long_asset_sum": 9479787850465,
		"num_equity_funds": 102,
		"equity_fund_net_assets": 6685662953311,
		"equity_fund_long_assets": 6693021730642,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 37155449111,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 36330475801,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 151,
		"t_asset_sum": 37640354692,
		"t_m_count_sum": 163,
		"t_m_asset_sum": 54649341939,
		"t_all_count_sum": 314,
		"t_all_asset_sum": 92289696631,
		"t_all_weight_total": 0.013788943222532686,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202505",
		"fund_id": 599,
		"net_asset_sum": 3645491316893,
		"long_asset_sum": 3860067552441,
		"num_equity_funds": 314,
		"equity_fund_net_assets": 2460847808604,
		"equity_fund_long_assets": 2475314677277,
		"num_e_sri": 36,
		"num_e_usf": 0,
		"sri_long_assets": 56836331464,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 48766055273,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 253,
		"t_asset_sum": 14997537200,
		"t_m_count_sum": 244,
		"t_m_asset_sum": 17979204383,
		"t_all_count_sum": 497,
		"t_all_asset_sum": 32976741583,
		"t_all_weight_total": 0.013322242172165547,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202505",
		"fund_id": 548,
		"net_asset_sum": 3791547530646,
		"long_asset_sum": 3871346904413,
		"num_equity_funds": 301,
		"equity_fund_net_assets": 2512922676678,
		"equity_fund_long_assets": 2525351783947,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 7631726560,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 6570343630,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 240,
		"t_asset_sum": 12191309661,
		"t_m_count_sum": 275,
		"t_m_asset_sum": 16826391753,
		"t_all_count_sum": 515,
		"t_all_asset_sum": 29017701414,
		"t_all_weight_total": 0.011490558106976592,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202505",
		"fund_id": 95,
		"net_asset_sum": 2780626311687,
		"long_asset_sum": 2798338795972,
		"num_equity_funds": 32,
		"equity_fund_net_assets": 1788011584506,
		"equity_fund_long_assets": 1792319233510,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 75,
		"t_asset_sum": 50460139091,
		"t_m_count_sum": 26,
		"t_m_asset_sum": 8028572308,
		"t_all_count_sum": 101,
		"t_all_asset_sum": 58488711399,
		"t_all_weight_total": 0.03263297648402637,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "State Street",
		"as_of": "202505",
		"fund_id": 191,
		"net_asset_sum": 1547410794506,
		"long_asset_sum": 1547858813558,
		"num_equity_funds": 106,
		"equity_fund_net_assets": 1231426334693,
		"equity_fund_long_assets": 1231428610652,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 2186469252,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2173681880,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 133,
		"t_asset_sum": 7914209351,
		"t_m_count_sum": 92,
		"t_m_asset_sum": 11433772433,
		"t_all_count_sum": 225,
		"t_all_asset_sum": 19347981784,
		"t_all_weight_total": 0.015711817653607945,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202505",
		"fund_id": 94,
		"net_asset_sum": 627457362694,
		"long_asset_sum": 627471550028,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 539302469998,
		"equity_fund_long_assets": 539302963954,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 23616043,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 23616043,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 73,
		"t_asset_sum": 5797877390,
		"t_m_count_sum": 69,
		"t_m_asset_sum": 4009409710,
		"t_all_count_sum": 142,
		"t_all_asset_sum": 9807287100,
		"t_all_weight_total": 0.018185116262102567,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202505",
		"fund_id": 176,
		"net_asset_sum": 892172421546,
		"long_asset_sum": 897007337054,
		"num_equity_funds": 74,
		"equity_fund_net_assets": 583931459083,
		"equity_fund_long_assets": 584504810285,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 23319764,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 23319764,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 31,
		"t_asset_sum": 1288854733,
		"t_m_count_sum": 52,
		"t_m_asset_sum": 2095391025,
		"t_all_count_sum": 83,
		"t_all_asset_sum": 3384245758,
		"t_all_weight_total": 0.005789936538503196,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"as_of": "202505",
		"fund_id": 14,
		"net_asset_sum": 755500000033,
		"long_asset_sum": 758037883480,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 517099999986,
		"equity_fund_long_assets": 519155661595,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 9,
		"t_asset_sum": 3346465669,
		"t_m_count_sum": 8,
		"t_m_asset_sum": 4326670578,
		"t_all_count_sum": 17,
		"t_all_asset_sum": 7673136247,
		"t_all_weight_total": 0.01478002998835812,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202505",
		"fund_id": 165,
		"net_asset_sum": 679890700316,
		"long_asset_sum": 680767312094,
		"num_equity_funds": 61,
		"equity_fund_net_assets": 443993595870,
		"equity_fund_long_assets": 444005022828,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44155676006,
		"usf_long_assets": 13836867207,
		"equity_fund_sri_long_assets": 36442479238,
		"equity_fund_usf_long_assets": 6911157513,
		"sustainable_manager": 0,
		"t_count_sum": 54,
		"t_asset_sum": 1819412320,
		"t_m_count_sum": 71,
		"t_m_asset_sum": 3890060881,
		"t_all_count_sum": 125,
		"t_all_asset_sum": 5709473201,
		"t_all_weight_total": 0.012859028406108263,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202505",
		"fund_id": 328,
		"net_asset_sum": 1012535549281,
		"long_asset_sum": 1033393353807,
		"num_equity_funds": 198,
		"equity_fund_net_assets": 726913061641,
		"equity_fund_long_assets": 730163966573,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 8686411959,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 6010436600,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 92,
		"t_asset_sum": 2938964588,
		"t_m_count_sum": 109,
		"t_m_asset_sum": 5893699878,
		"t_all_count_sum": 201,
		"t_all_asset_sum": 8832664466,
		"t_all_weight_total": 0.01209682327581271,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 918
// module chunks = 0